export const sickLeave = (state) => state.sickLeave.sickLeave
export const employerData = (state) => state.sickLeave.employerData?.data?.content
